import React, { useRef, useEffect } from "react";
import PropTypes from "prop-types";

import Str from "shared/components/Str";
import OkInput from "shared/components/oknf/OkInput";
import { submitOnEnterKeyDown } from "apps/phone_verification/util/helpers";

const VerificationScreen = ({ verificationCode, setVerificationCode, onNext, onBack }) => {
	const inputRef = useRef(null);
	useEffect(() => {
		inputRef.current.focus();
	}, []);

	return (
		<div className="phone-verification-intro-screen">
			<h3 className="phone-verification-title">
				<Str>Enter the code</Str>
			</h3>
			<p className="phone-verification-subtitle">
				<Str>We sent you a code to verify your phone number.</Str>
			</p>
			<OkInput
				ref={inputRef}
				className="phone-verification-input text-center"
				value={verificationCode}
				onChange={(event) => setVerificationCode(event.target.value.toUpperCase())}
				onKeyDown={(event) => submitOnEnterKeyDown({
					event,
					onSubmit: onNext,
					disabled: !verificationCode,
				})}
				maxLength={10}
			/>
			<button className="phone-verification-button" onClick={onBack}>
				<Str>
					{"I didn't get a code"}
				</Str>
			</button>
			<button className="phone-verification-next-button" onClick={onNext} disabled={!verificationCode}>
				<Str>Next</Str>
			</button>
		</div>
	);
};

VerificationScreen.propTypes = {
	verificationCode: PropTypes.string.isRequired,
	setVerificationCode: PropTypes.func.isRequired,
	onNext: PropTypes.func.isRequired,
	onBack: PropTypes.func.isRequired,
};

export default VerificationScreen;



// WEBPACK FOOTER //
// ./src/apps/phone_verification/components/VerificationScreen.jsx